export default "__VITE_ASSET__CLFKPHzA__"